import React from 'react';
import Button from '../next-ui/Button';
import AnimatedNeki from './AnimatedNeki';
import ProgressBar from '../next-ui/ProgressBar';
import { isNumber } from 'lodash-es';
import { cx } from 'cva';

function InKindDonationItem(props) {
  const { item, onChange } = props;
  const { title, description, quantity, donatedQuantity } = item;

  const [value, setValue] = React.useState(0);
  const [targetMet, setTargetMet] = React.useState(
    donatedQuantity === quantity,
  );
  const [showTargetMetAnimation, setShowTargetMetAnimation] =
    React.useState(false);

  React.useEffect(() => {
    if (showTargetMetAnimation) {
      setTimeout(() => {
        setShowTargetMetAnimation(false);
      }, 50);
    }
  }, [showTargetMetAnimation]);

  React.useEffect(() => {
    onChange(value);
  }, [value]);

  const inputRef = React.useRef(null);

  const handleOnHover = () => {
    inputRef.current.focus();
  };

  const handleValueChange = (e) => {
    let val = Number(e.target.value);
    if (isNaN(val) || !isNumber(val)) {
      val = value;
    }

    val = Math.min(quantity - donatedQuantity, val);

    setValue(val);
    if (val + donatedQuantity === quantity) {
      inputRef.current.blur();
      setShowTargetMetAnimation(true);
      setTargetMet(true);
    } else {
      setTargetMet(false);
    }
  };

  const handleIncrement = () => {
    if (value + donatedQuantity < quantity) {
      setValue((prev) => prev + 1);

      if (value + donatedQuantity + 1 === quantity) {
        inputRef.current.blur();
        setShowTargetMetAnimation(true);
        setTargetMet(true);
      } else {
        setTargetMet(false);
      }
    }
  };

  const handleDecrement = () => {
    if (value > 0) {
      setValue((prev) => prev - 1);
      setTargetMet(false);
    }
  };

  return (
    <div
      className="flex w-full flex-col items-start justify-center gap-2.5"
      onMouseEnter={handleOnHover}>
      <div className="group flex h-8 items-center gap-2 rounded-full border border-chips-secondary bg-transparent px-3 py-1 hover:border-none hover:bg-chips-secondary">
        <p className="line-clamp-1 font-dmsans text-14 text-secondary group-hover:font-medium group-hover:text-text-primary">
          {title}
        </p>
        <div className="relative flex items-center gap-2">
          <Button
            variant="text"
            size="xs"
            className="font-semibold disabled:font-normal"
            disabled={value === 0}
            onClick={handleDecrement}>
            -
          </Button>
          <input
            ref={inputRef}
            value={value}
            onChange={handleValueChange}
            className="w-8 border-none bg-transparent outline-none ring-0"
          />
          <Button
            variant="text"
            size="xs"
            className="font-semibold disabled:font-normal"
            disabled={targetMet}
            onClick={handleIncrement}>
            +
          </Button>
          <div className="absolute left-1/2 top-0">
            <AnimatedNeki show={showTargetMetAnimation} />
          </div>
        </div>
      </div>
      <ProgressBar
        size="small"
        background="white"
        value={donatedQuantity + value}
        max={quantity}
        className="w-full"
      />
    </div>
  );
}

export default InKindDonationItem;
